import { createSelector } from 'reselect';

const containerSelector = createSelector([
  (store) => store.apps.jobs,
  (store, props) => props.match.params.username,
  (store, props) => props.isOpenSauceUser,
  (store) => store.user,
  (store, props) => props.isSubaccountDashboard,
  (store) => store.experiments,
],
(jobs, username, isOpenSauceUser, user, isSubaccountDashboard, experiments) => ({
  automatedLoading: jobs.flatJobs.get('automatedLoading'),
  cloudType: jobs.flatJobs.get('cloudType'),
  experiments,
  filters: jobs.filters,
  filtersInitialized: jobs.filters.get('filtersInitialized'),
  isOpenSauceUser: isOpenSauceUser || !user.isAuthenticated(),
  jobsTeamSharingFeatureEnabled: !isOpenSauceUser,
  jobsTeamSharingEnabled: jobs.users.get('user').organization.settings ?
    jobs.users.get('user').organization.settings.jobs_cross_team_sharing :
    true,
  organizationId: jobs.users.get('user').organization.id || user.organization.id,
  orgTeams: jobs.filters.get('orgTeams'),
  orgUsers: jobs.filters.get('orgUsers'),
  rdcOffset: jobs.flatJobs.get('rdcOffset'),
  shouldFetchOrgUsers: !isOpenSauceUser && !isSubaccountDashboard && user.isAuthenticated(),
  user: jobs.users.get('user'),
  username: username || jobs.users.get('user').username,
}));

const automatedJobsSelector = createSelector([
  (store) => store.apps.jobs,
  (store) => store.user,
],
(jobs, user) => ({
  automated: jobs.flatJobs.get('automated'),
  automatedLoading: jobs.flatJobs.get('automatedLoading'),
  isPerformanceEnabled: user.get('performance_enabled'),
  rdc: jobs.flatJobs.get('rdc'),
  rdcLoading: jobs.flatJobs.get('rdcLoading'),
  rdcMoreAvailable: jobs.flatJobs.get('rdcMoreAvailable'),
}));

export default containerSelector;
export { automatedJobsSelector, containerSelector };
